export const PRODUCTS = [
  {
    id: "game",
    name: "Game",
    full: "POW Game Ball",
    colour: "Classic white",
    tag: "Everyday play",
    price: 70,
    outOfStock: true,
    image: "/images/pow-game.jpg",
    blurb: "The classic white ball for club days, practice and everyday play.",
  },
  {
    id: "fluoro",
    name: "Fluorescent",
    full: "POW Fluorescent Ball",
    colour: "Yellow · Green · Pink · Orange",
    tag: "High visibility",
    price: 60,
    image: "/images/pow-fluoro.jpg",
    images: {
      Yellow: "/images/pow-fluoro-yellow.jpg",
      Green: "/images/pow-fluoro-green.jpg",
      Pink: "/images/pow-fluoro-pink.jpg",
      Orange: "/images/pow-fluoro-orange.jpg",
    },
    colors: ["Yellow", "Green", "Pink", "Orange"],
    blurb: "Vivid speckled fluoro colours that stand out against grass and dust.",
  },
  {
    id: "splatter",
    name: "Splatter",
    full: "POW Splatter Ball",
    colour: "White with red & blue speckle",
    tag: "Best value",
    price: 50,
    image: "/images/pow-splatter.jpg",
    blurb: "A speckled red and blue finish that's easy to pick out on the field.",
  },
];

export const productById = (id) => PRODUCTS.find((p) => p.id === id);

export const STATES = [
  ["NSW", "New South Wales"],
  ["QLD", "Queensland"],
  ["VIC", "Victoria"],
  ["ACT", "Australian Capital Territory"],
  ["SA", "South Australia"],
  ["TAS", "Tasmania"],
  ["WA", "Western Australia"],
  ["NT", "Northern Territory"],
];

export const ZONE = { NSW: "east", ACT: "east", VIC: "east", QLD: "east", SA: "central", TAS: "central", WA: "west", NT: "west" };
export const ZONE_LABEL = { east: "NSW · ACT · VIC · QLD", central: "SA · TAS", west: "WA · NT" };
export const RATES = { east: [12, 16, 22, 30], central: [15, 20, 27, 36], west: [18, 25, 34, 45] };
export const TIERS = ["1–2 balls", "3–6 balls", "7–12 balls", "13+ balls"];

export const zoneForPostcode = (p) => {
  const n = Number(p);
  if (!p || p.length !== 4) return null;
  if ((n >= 800 && n <= 999) || (n >= 6000 && n <= 6999)) return "west";
  if ((n >= 5000 && n <= 5999) || (n >= 7000 && n <= 7999)) return "central";
  if ((n >= 1000 && n <= 2599) || (n >= 2619 && n <= 2999)) return "east";
  if ((n >= 200 && n <= 299) || (n >= 3000 && n <= 3999) || (n >= 8000 && n <= 8999)) return "east";
  if ((n >= 4000 && n <= 4999) || (n >= 9000 && n <= 9999)) return "east";
  return null;
};

export const postageFor = (state, qty) => {
  if (!state || !ZONE[state] || qty < 1) return 0;
  const t = qty <= 2 ? 0 : qty <= 6 ? 1 : qty <= 12 ? 2 : 3;
  return RATES[ZONE[state]][t];
};

export const BANK = {
  accountName: "Polocrosse",
  bank: "Commonwealth Bank",
  bsb: "067873",
  account: "123418785",
};

export const CONTACT = { email: "PowPolocrosseBalls@gmail.com" };

export const aud = (n) => `$${Number(n || 0).toFixed(2)}`;
